// project-imports
import {
  ADD_TESTIMONIAL_BEGIN,
  ADD_TESTIMONIAL_FAILURE,
  ADD_TESTIMONIAL_SUCCESS,
  GET_TESTIMONIAL_BEGIN,
  GET_TESTIMONIAL_FAILURE,
  GET_TESTIMONIAL_SUCCESS,
} from "../constants/actions";

// State variable initialization
const initialState = {
  testimonialLoading: false,
  testimonialError: null,
  testimonials: [],
  reviews: [],
  ebooksReviews: [],
  oneOnOneReviews: []
};

const testimonialReducer = (state = initialState, action) => {

  if (action.type === GET_TESTIMONIAL_BEGIN) {
    // Set loading state
    return {
      ...state,
      testimonialLoading: action.payload,
      testimonialError: null,
    };
  }

  if (action.type === GET_TESTIMONIAL_SUCCESS) {
    let data = Array.isArray(action.payload) ? action.payload : [];
    let reviewData = data.filter(review => review?.image && review?.image.includes(":::") || review?.email && review?.email.includes(":::"));
    let ebookData = data.filter(review => review?.image && !review?.image.includes("1:1 Salesforce Consultation") || review?.email && !review?.email.includes("1:1 Salesforce Consultation"));
    let oneOnOneData = data.filter(review => review?.image && review?.image.includes("1:1 Salesforce Consultation") || review?.email && review?.email.includes("1:1 Salesforce Consultation"));
    // Update state with all testimonial 
    return {
      ...state,
      testimonialLoading: false,
      testimonials: Array.isArray(action.payload) ? action.payload : [],
      reviews: reviewData,
      ebooksReviews: Array.isArray(ebookData) ? ebookData : [],
      oneOnOneReviews: Array.isArray(oneOnOneData) ? oneOnOneData : [],
      testimonialError: null
    };
  }

  if (action.type === GET_TESTIMONIAL_FAILURE) {
    // Set error state
    return {
      ...state,
      testimonialLoading: false,
      testimonialError: action.payload,
    };
  }

  if (action.type === ADD_TESTIMONIAL_BEGIN) {
    // Set loading state
    return {
      ...state,
      testimonialLoading: action.payload,
      testimonialError: null,
    };
  }

  if (action.type === ADD_TESTIMONIAL_SUCCESS) {

    // Update state with added testimonial
    return {
      ...state,
      testimonialLoading: false,
      testimonialError: null,
    };
  }

  if (action.type === ADD_TESTIMONIAL_FAILURE) {
    // Set error state
    return {
      ...state,
      testimonialLoading: false,
      testimonialError: action.payload,
    };
  }

  return state;
};

export default testimonialReducer;
